'use client'

/* eslint-disable react/function-component-definition */
import styled from 'styled-components'
import OopsFailed from '@public/images/oops_sorry_failed_red.svg'
import { SERVICE_UNAVAILABLE, SERVICE_UNAVAILABLE_DESCRIPTION } from './constants'

interface ErrorsMessageContainerWrapperProps {
  isMobile: boolean
}

export default function ErrorMessageContainer({ isMobile, handleClose }) {
  return (
    <ErrorMessageContainerWrapper isMobile={isMobile}>
      <StyledErrorIcon />
      <StyledTitle>{SERVICE_UNAVAILABLE}</StyledTitle>
      <StyledDescription>{SERVICE_UNAVAILABLE_DESCRIPTION}</StyledDescription>
      {!isMobile ? (
        <OkayButton onClick={handleClose}>Okay, got it</OkayButton>
      ) : (
        <GoBackToArticlesButton onClick={handleClose}>Go back to articles</GoBackToArticlesButton>
      )}
    </ErrorMessageContainerWrapper>
  )
}

const ErrorMessageContainerWrapper = styled.div<ErrorsMessageContainerWrapperProps>`
  ${props =>
    props.isMobile &&
    `position : fixed;
    bottom: 0;
    width: 100%;
    height: 100%;
    `};

  left: 0;
  padding: 14px;
  background: white;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
`

const StyledErrorIcon = styled(OopsFailed)`
  max-width: 140px;
  margin-bottom: 34px;

  @media (min-width: 700px) {
    max-width: 90px;
    margin-bottom: 24px;
  }
`

const StyledTitle = styled.p`
  font-weight: 600;
  font-size: 18px;
  line-height: 24px;
  margin-bottom: 28px;
`

const StyledDescription = styled.p`
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
`

const OkayButton = styled.button`
  color: #040222;
  font-weight: 600;
  font-size: 16px;
  line-height: 32px;
  background: #fff;
  margin-top: 40px;
  padding: 8px 16px;
  border: 1px solid #040222;
  border-radius: 8px;
  cursor: pointer;
  &:hover {
    background: #f8f7fc;
  }
  &:active {
    background: #e7e7f0;
  }
`

const GoBackToArticlesButton = styled.button`
  &:hover {
    background: #0b753e;
  }
  &:active {
    background: #064625;
  }
  color: #fff;
  font-weight: 600;
  font-size: 16px;
  line-height: 32px;
  background: #0fa457;
  margin-top: 40px;
  padding: 8px 16px;
  border-radius: 8px;
  cursor: pointer;
  bottom: 20px;
  position: absolute;
  border: none;
  width: calc(100% - 40px);
`
